// Translations
import paymentMethodRemovalDialog from '../components/payment-method-removal-dialog/translations/de'

// Translation: Account > Billing > Methods (German)
export default Object.freeze({
	card: {
		actions: {
			remove:''
		},
		fields: {
			default: '',
			expiration: '',
			name: '',
			number: ''
		}
	},
	components: { paymentMethodRemovalDialog },
	header: {
		controls: {
			add: ''
		},
		title: ''
	},
	subtitle: '',
	title: ''
})
